import { forwardRef } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AutoPayInfoDialog = ({ open, close }) => {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={close} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1 }}>
            About Auto-Pay
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <Typography variant="body1">
          When auto-pay is enabled, your invoices will be charged automatically
          48 hours after they are created — no action needed on your part.
        </Typography>

        <Divider />

        <Typography variant="subtitle2">How it works</Typography>
        <Typography variant="body2">
          Once you complete your first payment, your payment method is securely
          saved. From that point on, any new invoice will be scheduled for
          automatic payment 48 hours after it is issued. You will still receive
          the invoice notification so you can review it before the charge runs.
        </Typography>

        <Divider />

        <Typography variant="subtitle2">Payment methods &amp; fees</Typography>
        <Typography variant="body2">
          <strong>ACH bank account</strong> — if you sign up for auto-pay using
          ACH, we waive all processing fees. You are charged only the invoice
          amount, nothing more.
        </Typography>
        <Typography variant="body2">
          <strong>Credit card</strong> — standard credit card processing fees
          apply and will be added to the invoice total.
        </Typography>

        <Divider />

        <Typography variant="body2" color="text.secondary">
          You can disable auto-pay at any time from this page. Disabling it will
          not affect invoices that are already scheduled.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="contained">
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutoPayInfoDialog;
